import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { capturePageview } from '@/services/analytics';

const HIDE_FEEDBACK_PREFIXES = ['/admin', '/projects', '/dashboard', '/settings', '/team', '/contact', '/account', '/users', '/gminy'];

const RouteTracker: React.FC = () => {
  const location = useLocation();
  useEffect(() => {
    Sentry.setTag('route', location.pathname);
    Sentry.addBreadcrumb({
      category: 'navigation',
      message: `Navigated to ${location.pathname}`,
      level: 'info',
    });
    capturePageview({
      $current_url: window.location.href,
      route: location.pathname,
    });

    const hideFeedback = HIDE_FEEDBACK_PREFIXES.some((p) => location.pathname === p || location.pathname.startsWith(`${p}/`));
    document.body.toggleAttribute('data-hide-sentry-feedback', hideFeedback);
  }, [location.pathname]);
  return null;
};

export default RouteTracker;
